import { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Snackbar, Alert } from "@mui/material";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import styles from "./companyprofile.module.css";
import Loader from "../../components/Loader";
import { CountryList } from "../../components/Constants";
import { X } from "react-feather";
import { StorageSetItem } from "../../components/StorageComp";
import UpdateCompanyForm from "./UpdateCompanyForm";

const CompanyProfile = () => {
  const auth = authData();
  const [formOpenCompanyProfile, setFormOpenCompanyProfile] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [countryName, setCountryName] = useState("");
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    if (authData()?.company) {
      setCompanyData(authData()?.company);
    }
    if (authData()?.company?.company_address) {
      let conObj = CountryList?.filter(i => i?.value === authData()?.company?.delivery_country);
      if (conObj?.length > 0) {
        setCountryName(conObj[0]?.label);
      }
    }
  }, []);

  const onCompanyUpdate = (data) => {
    let authTemp = auth;
    let companyData = { ...authTemp?.company, ...data };
    authTemp = { ...authTemp, company: companyData };

    StorageSetItem("bookAuthData", JSON.stringify(authTemp), 24 * 60 * 60 * 1000);
  }

  return (<div className={`${styles.MainDiv}`}>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.PageTitleWrap}`}>
      <p className={`${styles.PageTitle}`}>Company Profile</p>
    </div>
    <div className={`${styles.MainCard}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>{companyData?.company_name}</p>
                <RouterLink className={`${styles.SideEditBU} `} onClick={(e) => setFormOpenCompanyProfile(true)}>Edit Company Profile</RouterLink>
              </div>
              <div className={`${styles.UserProDe}`}>
                <p className={`${styles.UserProDeList}`}><span>Company Name:</span> {companyData?.company_name}</p>
                <p className={`${styles.UserProDeList}`}><span>Email:</span> {companyData?.email}</p>
                <p className={`${styles.UserProDeList}`}><span>Phone No:</span> {companyData?.phone}</p>
                <p className={`${styles.UserProDeList}`}><span>Company Addr:</span> {companyData?.company_address}</p>
                <p className={`${styles.UserProDeList}`}><span>Delivery Country:</span> {countryName}</p>
                <p className={`${styles.UserProDeList}`}><span>Company Addr:</span> {companyData?.company_address}</p>
                <p className={`${styles.UserProDeList}`}><span>Reg Number:</span> {companyData?.reg_number}</p>
                <p className={`${styles.UserProDeList}`}><span>Vat Number:</span> {companyData?.vat_number}</p>
                <p className={`${styles.UserProDeList}`}><span>Payment Rec A/c:</span> {companyData?.payment_receiver_account}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      open={formOpenCompanyProfile}
      onClose={(e) => setFormOpenCompanyProfile(false)}
      fullWidth
      maxWidth="sm"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        {"Update Company"}
        <button onClick={(e) => setFormOpenCompanyProfile(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <UpdateCompanyForm setFormOpen={setFormOpenCompanyProfile.bind(this)} onLocal={onCompanyUpdate.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={companyData} />
      </DialogContent>
    </Dialog>

    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={(e) => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </div >);
};

export default withAdminAuth(CompanyProfile);